const $productDetails = $('.product-detail');
const $productNav = $('.product-nav');
const offset = $('header').height();

if ($productNav.length) {
  const self = {};

  /** Initialise the module. */
  self.initialise = function initialise() {
    const addClickEvent = function addClickEvent($navElement, $section) {
      if ($navElement.length && $section.length) {
        $navElement.click((e) => {
          e.preventDefault();

          $('html, body').stop().animate({
            scrollTop: $section.offset().top - offset,
          }, 900, 'swing');
        });
      } else {
        $navElement.hide();
      }
    };

    addClickEvent($('.nav-images', $productNav), $('.product-images', $productDetails));
    addClickEvent($('.nav-charge', $productNav), $('.product-chargers', $productDetails));
    addClickEvent($('.nav-videos', $productNav), $('.product-video-thumbs', $productDetails));
    addClickEvent($('.nav-awards', $productNav), $('.product-awards', $productDetails));
    addClickEvent($('.nav-specification', $productNav), $('.specifications', $productDetails));
    addClickEvent($('.nav-support', $productNav), $('.support', $productDetails));
    addClickEvent($('.nav-myryobi', $productNav), $('.my-ryobi-projects', $productDetails));
    addClickEvent($('.nav-featured', $productNav), $('.featured', $productDetails));
    addClickEvent($('.nav-reviews', $productNav), $('.product-reviews', $productDetails));
    addClickEvent($('.nav-learnmore1', $productNav), $('.learnmore1', $productDetails));
    addClickEvent($('.nav-learnmore2', $productNav), $('.learnmore2', $productDetails));
  };

  self.initialise();
}
